export class WhiteboardHelper {
  /*
   ngx-canvas-whiteboard library is using reverse calculation of aspect ratio
  */
  public static getAspectRatio(height: number, width: number): number {
    return width === 0 ? 0 : Number((height / width).toFixed(2));
  }
}
